if (!customElements.get('top-photo-deck')) {
  customElements.define('top-photo-deck', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.index = 0;
      this.cards = [...this.querySelectorAll('[data-card]')];
      this.dots = [...this.querySelectorAll('[data-dot]')];
      this.querySelector('.top-photo-deck__controls').hidden = false;
      this.querySelector('.top-photo-deck__hint').hidden = false;
      this.querySelector('[data-prev]').addEventListener('click', () => this.show(this.index - 1));
      this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1));
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index)));
      this.addEventListener('keydown', (event) => {
        const targets = {ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.cards.length - 1};
        if (!(event.key in targets)) return;
        event.preventDefault();
        this.show(targets[event.key]);
      });
      const stack = this.querySelector('.top-photo-deck__stack');
      stack.addEventListener('pointerdown', (event) => {
        if (!event.isPrimary || event.button !== 0) return;
        this.start = {x:event.clientX,y:event.clientY,id:event.pointerId};
        stack.setPointerCapture(event.pointerId);
      });
      stack.addEventListener('pointerup', (event) => {
        if (!this.start || this.start.id !== event.pointerId) return;
        const dx=event.clientX-this.start.x,dy=event.clientY-this.start.y;
        this.start=null;
        if (Math.abs(dx)>45 && Math.abs(dx)>Math.abs(dy)*1.2) this.show(this.index+(dx<0?1:-1));
      });
      stack.addEventListener('pointercancel', () => {this.start=null;});
    }
    show(index) {
      this.index=(index+this.cards.length)%this.cards.length;
      this.cards.forEach((card,i) => {
        const slot=(i-this.index+this.cards.length)%this.cards.length;
        card.dataset.slot=String(slot);
        card.inert=slot!==0;
        card.setAttribute('aria-hidden',String(slot!==0));
      });
      this.dots.forEach((dot,i) => i===this.index ? dot.setAttribute('aria-current','true') : dot.removeAttribute('aria-current'));
      this.querySelector('[data-status]').textContent=this.cards[this.index].getAttribute('aria-label');
    }
  });
}
